import {
  FETCH_JWT_DATA,
  FETCH_JWT_DATA_ERROR,
  FETCH_JWT_DATA_LOADING,
  JWT_EXPIRED_OR_INVALID
} from "../constants";
import { userFetchData, userFetchDataSuccess } from "./UserActions";
import { currentError } from "./ErrorActions";

export function jwtFetchData(url, username, password, reLogin = false) {
  return dispatch => {
    dispatch(userFetchDataSuccess({}));
    dispatch(jwtFetchDataSuccess({}));
    dispatch(jwtIsLoading(true));
    dispatch(jwtHasErrored(false));
    let data = JSON.stringify({ username, password });
    const headers = new Headers({
      "Content-Type": "application/json",
      "cache-control": "no-cache"
    });

    fetch(url, {
      method: "POST",
      headers,
      mode: "cors",
      body: data
    })
      .then(data => data.json())
      .then(jwt => {
        dispatch(jwtIsLoading(false));
        if (jwt.error) {
          dispatch(jwtHasErrored(true));
          dispatch(currentError(jwt));
        } else {
          dispatch(jwtExpiredOrInvalid(false));
          dispatch(jwtFetchDataSuccess(jwt));
          // if (!reLogin) {
          //   dispatch(userFetchData(reLogin, true));
          // }
          dispatch(userFetchData(false, !reLogin));
        }
      })
      .catch(() => dispatch(jwtHasErrored(true)));
  };
}
export function jwtRefresh(url) {
  return (dispatch, getState) => {
    const body = { refresh_token: getState().jwt.refresh_token };

    const headers = new Headers({
      "Content-Type": "application/json",
      "cache-control": "no-cache"
    });

    fetch(url, {
      method: "POST",
      headers,
      mode: "cors",
      body: JSON.stringify(body)
    })
      .then(data => data.json())
      .then(jwt => {
        dispatch(jwtFetchDataSuccess(jwt));
        sessionStorage.setItem("time", 1);
      })
      .catch(() => dispatch(jwtHasErrored(true)));
  };
}

export function jwtHasErrored(bool) {
  return {
    type: FETCH_JWT_DATA_ERROR,
    hasErrored: bool
  };
}

export function jwtIsLoading(bool) {
  return {
    type: FETCH_JWT_DATA_LOADING,
    isLoading: bool
  };
}

export function jwtExpiredOrInvalid(jwtError) {
  return {
    type: JWT_EXPIRED_OR_INVALID,
    jwtError
  };
}

export function jwtFetchDataSuccess(jwt) {
  return {
    type: FETCH_JWT_DATA,
    jwt
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/JWTActions.js